<template>
  <div>
    <model-table
      :collection="memberships"
      :columns="[
        { field: 'id' },
        { name: 'owner', field: membership => membership.owner.name, component: 'chip' },
        { name: 'members', field: membership => membership.members.data.length, component: 'chip' },
        { name: 'state', field: membership => stateIcon(membership.state), component: 'icon' },
        { name: 'renewing', field: membership => !membership.canceledAt, component: 'checkmark' },
        { field: 'term' },
        { name: 'createdAt', field: row => row.createdAt.i18n('timestamp'), component: 'date-time' },
        { name: 'canceledAt', field: row => row.canceledAt ? row.canceledAt.i18n('timestamp') : null, component: 'date-time' },
        { name: 'actions', align: 'right' }
      ]"
      :show-add="false"
      :show-edit="false"
      :submodel="submodel"
    >
      <template #header-controls>
        <div class="q-mt-xs">
          <q-btn-toggle
            v-model="state"
            class="q-my-xs"
            size="sm"
            outline
            toggle-color="primary"
            :options="stateOptions"
          />
        </div>
      </template>
      <membership-form @modify-membership="$emit('modify-membership')" />
    </model-table>
  </div>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import MembershipForm from 'src/modules/admin/membership/MembershipForm'
import QueryEncodableOptionsMixin from 'src/modules/admin/mixins/QueryEncodableOptionsMixin'
import ShowingBadgesDisplayCell from 'src/modules/admin/showing-badge/components/ShowingBadgesDisplayCell'

export default {
  name: 'MembershipTable',
  components: {
    ModelTable,
    MembershipForm
  },
  mixins: [QueryEncodableOptionsMixin],
  props: {
    userId: {
      type: Number,
      required: false,
      default: null
    },
    submodel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['modify-membership'],
  data () {
    return {
      state: null,
      activeCount: null,
      inactiveCount: null,
      pendingCount: null
    }
  },
  computed: {
    defaultQueryEncodableOptions () {
      return {
        state: null
      }
    },
    stateOptions () {
      return [
        {
          label: `Active${this.activeCount !== null ? ` (${this.activeCount.toLocaleString()})` : ''}`,
          value: 'active'
        },
        {
          label: `Inactive${this.inactiveCount !== null ? ` (${this.inactiveCount.toLocaleString()})` : ''}`,
          value: 'inactive'
        },
        {
          label: `Pending${this.pendingCount !== null ? ` (${this.pendingCount.toLocaleString()})` : ''}`,
          value: 'pending'
        }
      ]
    }
  },
  created () {
    _.extend(this, { ShowingBadgesDisplayCell })
    if (!this.submodel) {
      this.fetchMembershipCount()
    }
  },
  methods: {
    decodeUrlParamOption (key, value) {
      switch (key) {
        case 'state':
          return _.includes(_.map(this.stateOptions, 'value'), value) ? value : undefined
        default:
          return undefined
      }
    },
    stateIcon (state) {
      if (state === 'active') return { name: 'check', color: 'positive', tooltip: 'Active' }
      if (state === 'pending') return { name: 'question-mark', color: 'warning', tooltip: 'Pending' }
      if (state === 'inactive') return { name: 'cancel', color: 'negative', tooltip: 'Inactive' }
    },
    async fetchMembershipCount () {
      try {
        await this.membershipCount.fetch()

        this.activeCount = this.membershipCount.value.activeCount
        this.inactiveCount = this.membershipCount.value.inactiveCount
        this.pendingCount = this.membershipCount.value.pendingCount
      } catch (error) {
        this.$rollbar.error('Failed Fetching Membership Counts', error)
      }
    }
  },
  models: {
    memberships: {
      owner: {
        fields: ['id', 'firstName', 'lastName']
      },
      members: 'id',
      site: {
        fields: ['id', 'name']
      },
      variables () {
        return {
          userId: this.userId,
          state: this.state
        }
      },
      immediate: false
    },
    membershipCount: {
      immediate: false
    }
  }
}
</script>
